import {SbBlokData, storyblokEditable} from "@storyblok/react";
import ButtonGroup from "../partials/ButtonGroup";
import {addSlashIfNotAbsoluteUrl} from "../../utils/Helpers";
import DynamicHeading from "../partials/DynamicHeading";

export type TTextHeroBlok = {
    subheader: string,
    subheader_button_text: string,
    subheader_link: any,
    title: string,
    subtitle: string,
    buttons: Array<any>,
    container_padding: string,
} & SbBlokData;


export default function TextHero({blok}: { blok: TTextHeroBlok }) {

    const buttons = <ButtonGroup buttons={blok?.buttons ?? []}/>

    return (
        <div className="relative isolate overflow-hidden mb-12 " {...storyblokEditable(blok)}>
            <main>
                <div className="relative px-6 lg:px-8 ">
                    <div className={"mx-auto max-w-2xl " + (blok.container_padding || "py-16 sm:py-32 lg:py-56")}>
                        {blok.subheader?.length > 0 &&
                            <div className="hidden sm:mb-8 sm:flex sm:justify-center">
                                <div
                                    className="relative rounded-full py-1 px-3 text-sm leading-6 text-gray-600 ring-1 ring-gray-900/10 hover:ring-gray-900/20 bg-white/80">
                                    {blok?.subheader}{' '}

                                    <a href={addSlashIfNotAbsoluteUrl(blok.subheader_link?.cached_url)}
                                       className="font-semibold text-secondary hover:text-primary">
                                        <span className="absolute inset-0" aria-hidden="true"/>
                                        {blok.subheader_button_text} <span aria-hidden="true">&rarr;</span>
                                    </a>
                                </div>
                            </div>}
                        <div className="text-center">
                            <DynamicHeading heading={blok.heading} fallback={'h2'}
                                            className="text-4xl font-bold tracking-tight text-gray-900 md:text-5xl lg:text-6xl">
                                {blok.title}
                            </DynamicHeading>
                            {blok.subtitle && <p className="mt-6 text-lg leading-8 text-gray-600">
                                {blok.subtitle}
                            </p>}
                            {blok?.buttons.length > 0 &&
                                <div className="mt-10 flex items-center justify-center gap-x-6">
                                    {buttons}
                                </div>}
                        </div>
                    </div>
                    <div
                        className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]">
                    </div>
                </div>
            </main>
        </div>
    )


}